import React from 'react';
import Tiles from './Tiles';
import NavBar from './navbar_in';

class MakehairTile extends React.Component{

    Onclick(e)
    {
        this.props.history.push('/');
    }

    render()
    {
        function importAll(r) {
            let images = [];
            r.keys().map((item, index) => { images[index]={'image': r(item), 'id': index}; });     //['image'] = r(item); images[index]['id'] = index });
            return images;
        }
        let contex = require.context('../assets/images/makeup_hair', false, /\.(png|jpe?g|svg|JPG|PNG)$/);
        const images = importAll(contex);

       
        return(
            <div>
                <NavBar />
            <Tiles data={images} />
            </div>
        );

    }
}

export default MakehairTile;


// WEBPACK FOOTER //
// ./src/components/MakehairTile.js